import { useEffect, useState } from "react";
import benefitIllustration from "../../../assets/icons/benefit.jpg";
import { getConfig, type AppConfig } from "../../../utils/config";

const Footer = () => {
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    getConfig().then(setConfig);
  }, []);

  return (
    <div className="footer-section">
      <img
        src={benefitIllustration}
        alt="Benefit"
        className="footer-illustration"
      />
      <p className="footer-text">
        רוצה גם לשמוע מה העוקבים שלך באמת חושבים? הצטרף עכשיו לטוויסט
      </p>
      <a
        href={`https://wa.me/${config?.PUBLIC_INDEX_JOIN_WHATSAPP_PHONE}?text=${encodeURIComponent("הצטרפות לטוויסט אינדקס")}`}
        className="footer-cta-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        הצטרפות &gt;
      </a>
    </div>
  );
};

export default Footer;
